import { render } from "./SuperviseurValidationPage.vue?vue&type=template&id=a64960ca&ts=true"
import script from "./SuperviseurValidationPage.vue?vue&type=script&lang=ts"
export * from "./SuperviseurValidationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__